// DS: IL10.1
import React from 'react';
export const Success = ({ className })=>{
    return /*#__PURE__*/ React.createElement("img", {
        alt: "",
        src: "https://st.deviantart.net/eclipse/global/svg/il10-1.svg",
        width: "140",
        height: "140",
        className: className
    });
};

//# sourceMappingURL=Success.js.map